import React from 'react';
import { createRoot } from 'react-dom/client';
import ProductDirectoryWithFilters from '../../src/js/productDirectory/ProductDirectoryWithFilters.jsx';
import ProductDirectory from '../../src/js/productDirectory/ProductDirectory.jsx';
import '../../src/styles/products-directory.less';
import { authController } from '@reedexpo/authorization-component-ui';
export default ProductDirectory;

function renderComponent(props, testVariants, elementId) {
  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<ProductDirectoryWithFilters {...props} testVariants={testVariants} />);
}

if (global.window && global.window.document) {
  const testVariants = window.testVariants;
  const { props, elementId } = window.reactSettingsProductsDirectory;
  const authSettings = window.authSettings;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
    if (authSettings.forceLogin) {
      authController.login(window.location.href).then((canRender) => {
        if (canRender) {
          renderComponent(props, testVariants, elementId);
        }
      });
    } else {
      renderComponent(props, testVariants, elementId);
    }
  } else {
    renderComponent(props, testVariants, elementId);
  }
}
